import React, { useContext } from 'react'
import { TrackingContext } from '../utils'

const useTrackingContext = () => {
  const { tracker } = useContext(TrackingContext)

  if (!tracker) {
    throw new Error(`useTrackingContext used outside provider/or provider is missing tracker`)
  }

  return tracker
}

export default useTrackingContext
